import React from "react";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CloseIcon from "@mui/icons-material/Close";
import "./CopilotUpsell.css";

const PLAN_LABELS = {
  starter: "Starter",
  growth: "Growth",
  enterprise: "Enterprise",
};

function UpsellCard({ plan, onClose, showClose }) {
  const planLabel = PLAN_LABELS[plan] || plan;

  return (
    <>
      {showClose && onClose && (
        <button type="button" className="cop-upsell-close" onClick={onClose} aria-label="Cerrar">
          <CloseIcon sx={{ fontSize: 20 }} />
        </button>
      )}
      <div className="cop-upsell-icon">
        <AutoAwesomeIcon sx={{ fontSize: 36, color: "#0066cc" }} />
      </div>
      <h1 id="cop-upsell-title">Copiloto financiero</h1>
      <p>
        Consultá tus comprobantes en lenguaje natural. Incluido en planes Growth y Enterprise.
      </p>
      <p className="cop-upsell-plan">
        Plan actual: <strong>{planLabel}</strong>
      </p>
      <div className="cop-upsell-actions">
        <a className="cop-upsell-cta" href="mailto:ventas@tagnize.com?subject=Upgrade%20Copiloto">
          Contactar ventas
        </a>
      </div>
    </>
  );
}

/** Modal upsell — se muestra al intentar consultar sin feature habilitada. */
export function CopilotUpsellModal({ open, onClose, plan = "starter" }) {
  if (!open) return null;

  return (
    <div className="cop-upsell-modal-backdrop" onClick={onClose} role="presentation">
      <div
        className="cop-upsell-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="cop-upsell-title"
      >
        <div className="cop-upsell-card">
          <UpsellCard plan={plan} onClose={onClose} showClose />
        </div>
      </div>
    </div>
  );
}

/** Página upsell completa — legacy / fallback. */
export default function CopilotUpsell({ plan = "starter" }) {
  return (
    <div className="cop-upsell-page">
      <div className="cop-upsell-card">
        <UpsellCard plan={plan} />
      </div>
    </div>
  );
}
